import {
  enableProdMode,
  provideAppInitializer,
  Injector,
  inject,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { createTranslateLoader } from './app/app.module';
import { environment } from './environments/environment';
import { TimeoutService, SessionService } from './app/shared/services';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { HttpHeaderInterceptor, ErrorInterceptor, LoaderInterceptor } from './app/shared/interceptors';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizationModule, initializeTranslations } from './app/shared/modules/localization';
import { LoaderModule } from './app/shared/modules/loader';

import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      AppRoutingModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      LocalizationModule,
      LoaderModule
    ),
    provideAppInitializer(initializeTranslations),
    provideAppInitializer(() => {
      const initializerFn = ((injector: Injector) => () => {
        return injector.get(TimeoutService).init(injector.get(SessionService));
      })(inject(Injector));
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    provideNativeDateAdapter(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
}).catch(err => console.error(err));
